import React, { useEffect, useState, useRef } from "react";
import { format } from 'date-fns';
import moment from 'moment-timezone';
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import './CQProfessorAssignmentPopUp.css';
import "react-datepicker/dist/react-datepicker.css";
import { handleException } from "../../../app/util/util";
import { handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../app/util/HOC";

const DateInput = (props) => {
    const { testid, isOpen, ...rest } = props;
    return <input data-testid={testid} role="button" aria-expanded={isOpen} {...rest} />;
};

function CQProfessorAssignmentPopUp(props) {
    var qName = props.data.scheduledQuizName, qClass = props.data.scheduledQuizClass, qBtn = props.data.assignQuizBtn,
        qSD = props.data.assignQuizSD, qSDSplit = qSD.split("at"), qSDSplitTime = qSDSplit[1].trim().split(" "),
        qSDSplitTime2 = qSDSplitTime[0].split(":"), qED = props.data.assignQuizED, qEDSplit = qED.split("at"),
        qEDSplitTime = qEDSplit[1].trim().split(" "), qEDSplitTime2 = qEDSplitTime[0].split(":"),
        qTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, qIdentifier = props.data.assignQuizIdentifier,
        qClassId = props.data.assignClassId, qProductId = props.data.assignPID, qSemId = props.data.assigSemId,
        qId = props.data.assignQuizId, qpUserId = props.data.assignUserId, qSemED = props.data.scheduledQuizSemED,
        qSemEDSplit = qSemED.split("at"), qSemMaxDate = new Date(qSemEDSplit[0]), qSemSD = props.data.scheduledQuizSemSD, qSemSDSplit = qSemSD.split("at"),
        qSemSDSplitTime = qSemSDSplit[1].trim().split(" "), qSemSDSplitTime2 = qSemSDSplitTime[0].split(":");
    const cqProfQuizPopUpCloseRef = useRef(null);
    const cqProfQuizPopUpCloseConfirmRef = useRef(null);
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    const localCurrDate = dateConversion(new Date()), localCurrTime = timeConversion(), localCurrTS_1 = localCurrTime.split(":"), localCurrTS_2 = localCurrTS_1[1].split(/\s+/);
    const startHrs = timeRange(12, 'hrs'), startMins = timeRange(60, 'mins'), startType = ['AM', 'PM'], endHrs = timeRange(12, 'hrs'), endMins = timeRange(60, 'mins'), endType = ['AM', 'PM'],
        relHrs = timeRange(12, 'hrs'), relMins = timeRange(60, 'mins'), relType = ['AM', 'PM'], cloHrs = timeRange(12, 'hrs'), cloMins = timeRange(60, 'mins'), cloType = ['AM', 'PM'];
    const [qeResOpt, setQeResOpt] = useState(false);
    const [drResopt, setDrResOpt] = useState(false);
    const [fAssignQPP, setFAssignQPP] = useState(false);
    const [noEDTSelErr, setNoEDTSelErr] = useState(false);
    const [noClDTSelErr, setNoClDTSelErr] = useState(false);
    const [studSubResOpt, setStudSubResOpt] = useState(false);
    const [semExpiredErr, setSemExpiredErr] = useState(false);
    const [laterSemSelErr, setLaterSemSelErr] = useState(false);
    const [laterRDTSelErr, setLaterRDTSelErr] = useState(false);
    const [laterEDTSelErr, setLaterEDTSelErr] = useState(false);
    const [noResOptSelErr, setNoResOptSelErr] = useState(false);
    const [showResOptPopUp, setShowResOptPopUp] = useState(false);
    const [laterClDTSelErr, setLaterClDTSelErr] = useState(false);
    const [profQuizPopUpTitle, setProfQuizPopUpTitle] = useState("");
    const [mailCheckboxActive, setMailCheckboxActive] = useState(true);
    const [showResOptNxtPopup, setShowResOptNxtPopup] = useState(false);
    const [qRDprops, setQRDprops] = useState(props.data.assignQuizRelD);
    const [qRelsopt, setQRelsopt] = useState(props.data.assignQuizRelopt);
    const [showAssignQuizPopUp, setShowAssignQuizPopUp] = useState(props.show);
    const [qResultFlag, setQResultFlag] = useState(props.data.assignQuizResultFlag);
    const [selResOpt, setSelResOpt] = useState((qBtn === 'Assign to class') ? ' ' : qRelsopt);
    const [closeDate, setCloseDate] = useState(' '); const [selCloHrs, setSelCloHrs] = useState(' ');
    const [selCloMins, setSelCloMins] = useState(' '); const [selCloType, setSelCloType] = useState(' ');
    const [releaseDate, setReleaseDate] = useState(' '); const [selRelHrs, setSelRelHrs] = useState(' ');
    const [selRelMins, setSelRelMins] = useState(' '); const [selRelType, setSelRelType] = useState(' ');
    const [selEndHrs, setSelEndHrs] = useState((qBtn === 'Assign to class' || qBtn === 'Reopen Quiz') ? ' ' : qEDSplitTime2[0]);
    const [endDate, setEndDate] = useState((qBtn === 'Assign to class' || qBtn === 'Reopen Quiz') ? ' ' : new Date(qEDSplit[0]));
    const [selEndType, setSelEndType] = useState((qBtn === 'Assign to class' || qBtn === 'Reopen Quiz') ? ' ' : qEDSplitTime[1]);
    const [selEndMins, setSelEndMins] = useState((qBtn === 'Assign to class' || qBtn === 'Reopen Quiz') ? ' ' : qEDSplitTime2[1]);
    const [checkBox, setCheckBox] = useState((qBtn === 'Assign to class') && (new Date(qSemSDSplit[0]) >= new Date()) ? false : (qBtn === 'Edit scheduled assignment') ? false : true);
    const [startDate, setStartDate] = useState((qBtn === 'Assign to class') && (new Date(qSemSDSplit[0]) >= new Date()) ? new Date(qSemSDSplit[0]) : (qBtn === 'Assign to class') ? new Date() : new Date(qSDSplit[0]));
    const [selStartHrs, setSelStartHrs] = useState((qBtn === 'Assign to class') && (new Date(qSemSDSplit[0]) >= new Date()) ? qSemSDSplitTime2[0] : (qBtn === 'Assign to class') ? localCurrTS_1[0] : qSDSplitTime2[0]);
    const [selStartType, setSelStartType] = useState((qBtn === 'Assign to class') && (new Date(qSemSDSplit[0]) >= new Date()) ? qSemSDSplitTime[1] : (qBtn === 'Assign to class') ? localCurrTS_2[1] : qSDSplitTime[1]);
    const [selStartMins, setSelStartMins] = useState((qBtn === 'Assign to class') && (new Date(qSemSDSplit[0]) >= new Date()) ? qSemSDSplitTime2[1] : (qBtn === 'Assign to class') ? localCurrTS_2[0] : (qSDSplitTime2[1]));
    const [isStartDateCalendarOpen, setIsStartDateCalendarOpen] = useState(false);
    const [isEndDateCalendarOpen, setIsEndDateCalendarOpen] = useState(false);
    const [isReleaseDateCalendarOpen, setIsReleaseDateCalendarOpen] = useState(false);
    const [isCloseDateCalendarOpen, setIsCloseDateCalendarOpen] = useState(false);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    useEffect(() => {
        if (showAssignQuizPopUp) {
            cqProfQuizPopUpCloseRef.current.focus();
        }
    }, [showAssignQuizPopUp]);
    useEffect(() => {
        if (showResOptNxtPopup) {
            setTimeout(() => {
                if (
                    cqProfQuizPopUpCloseConfirmRef &&
                    cqProfQuizPopUpCloseConfirmRef.current &&
                    cqProfQuizPopUpCloseConfirmRef.current.focus
                ) {
                    cqProfQuizPopUpCloseConfirmRef.current.focus();
                }
            }, 1);
        }
    }, [showResOptNxtPopup]);
    function showRequiredModalDivs() {
        if (qBtn === 'Assign to class') {
            if (new Date(qSemSDSplit[0]) >= new Date()) {
                document.getElementById('profQuizPopUpCheckBox').disabled = true;
                document.getElementById('profQuizPopUpCheckBoxTxt').style.color = "grey";
            }
            document.getElementById('profQuizPopUpTitle_1').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_2').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_1').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_2').style.display = 'none';
            document.getElementById('profQuizPopUpDisSD').style.display = 'none';
            document.getElementById('profQuizPopUpDisST').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_2').style.display = 'none';
            setReleaseDate(endDate); setSelRelHrs(selEndHrs);
            setSelRelMins(selEndMins); setSelRelType(selEndType);
            setCloseDate(" "); setSelCloHrs(" ");
            setSelCloMins(" "); setSelCloType(" ");
            setProfQuizPopUpTitle(`${qName} for ${qClass} Quiz Assignment Information`);
        } else if (qBtn === 'Cancel Quiz') {
            document.getElementById('profQuizPopUpTitle_2').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_3').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_2').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_3').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_1').style.display = 'none';
            setProfQuizPopUpTitle(`Do you want to cancel this quiz?`);
        } else if (qBtn === 'Edit scheduled assignment') {
            if (new Date(qSemSDSplit[0]) >= new Date()) {
                document.getElementById('profQuizPopUpCheckBox').disabled = true;
                document.getElementById('profQuizPopUpCheckBoxTxt').style.color = "grey";
            }
            document.getElementById('profQuizPopUpTitle_1').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_2').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_1').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_2').style.display = 'none';
            document.getElementById('profQuizPopUpDisSD').style.display = 'none';
            document.getElementById('profQuizPopUpDisST').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_2').style.display = 'none';
            if (qResultFlag === true) {
                handleRadioBtns('stud_sub');
            } else {
                handleRadioBtns(selResOpt);
            }
            var qRD = qRDprops, qRDSplit = qRD.split("at"), qRDSplitTime = qRDSplit[1].trim().split(" "), qRDSplitTime2 = qRDSplitTime[0].split(":");
            var qCD = props.data.assignQuizCloseD === 'January 01, 3000 at 05:30 AM IST' ? '' : props.data.assignQuizCloseD;
            if (qCD !== '') {
                var qCDSplit = qCD.split("at"), qCDSplitTime = qCDSplit[1].trim().split(" "), qCDSplitTime2 = qCDSplitTime[0].split(":");
            }
            setReleaseDate(new Date(qRDSplit[0]));
            setSelRelHrs(qRDSplitTime2[0]);
            setSelRelMins(qRDSplitTime2[1]);
            setSelRelType(qRDSplitTime[1]);
            setCloseDate(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : new Date(qCDSplit[0])) : ' ') : ' ');
            setSelCloHrs(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime2[0]) : ' ') : ' ');
            setSelCloMins(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime2[1]) : ' ') : ' ');
            setSelCloType(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime[1]) : ' ') : ' ');
            setProfQuizPopUpTitle(`${qName} for ${qClass} Quiz Assignment Edit Information`);
        } else if (qBtn === 'End Quiz') {
            document.getElementById('profQuizPopUpTitle_1').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_3').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_1').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_3').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_1').style.display = 'none';
            if (qResultFlag === true) {
                handleRadioBtns('stud_sub');
            } else {
                handleRadioBtns(selResOpt);
            }
            setProfQuizPopUpTitle(`Quiz Cancellation Confirmation`);
        } else if (qBtn === 'Edit active assignment') {
            document.getElementById('profQuizPopUpTitle_1').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_2').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_1').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_2').style.display = 'none';
            document.getElementById('profQuizPopUpCheckBox').disabled = true;
            document.getElementById('profQuizPopUpCheckBoxTxt').style.color = "grey";
            document.getElementById('profQuizPopUpEneSD').style.display = 'none';
            document.getElementById('profQuizPopUpEneST').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_2').style.display = 'none';
            if (qResultFlag === true) {
                handleRadioBtns('stud_sub');
            } else {
                handleRadioBtns(selResOpt);
            }
            var qRD = qRDprops, qRDSplit = qRD.split("at"), qRDSplitTime = qRDSplit[1].trim().split(" "), qRDSplitTime2 = qRDSplitTime[0].split(":");
            var qCD = props.data.assignQuizCloseD;
            if (qCD !== '') {
                var qCDSplit = qCD.split("at"), qCDSplitTime = qCDSplit[1].trim().split(" "), qCDSplitTime2 = qCDSplitTime[0].split(":");
            }
            setReleaseDate(new Date(qRDSplit[0]));
            setSelRelHrs(qRDSplitTime2[0]);
            setSelRelMins(qRDSplitTime2[1]);
            setSelRelType(qRDSplitTime[1]);
            setCloseDate(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : new Date(qCDSplit[0])) : ' ') : ' ');
            setSelCloHrs(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime2[0]) : ' ') : ' ');
            setSelCloMins(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime2[1]) : ' ') : ' ');
            setSelCloType(qCD ? (qRelsopt === 'date_range' ? (qCDSplit[0] === 'January 01, 3000 ' ? ' ' : qCDSplitTime[1]) : ' ') : ' ');
            setProfQuizPopUpTitle(`${qName} for ${qClass} Quiz Assignment Edit Information`);
        } else if (qBtn === 'Reopen Quiz') {
            document.getElementById('profQuizPopUpTitle_1').style.display = 'none';
            document.getElementById('profQuizPopUpTitle_2').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_1').style.display = 'none';
            document.getElementById('profQuizPopUpBodyTxt_2').style.display = 'none';
            document.getElementById('profQuizPopUpCheckBox').disabled = true;
            document.getElementById('profQuizPopUpCheckBoxTxt').style.color = "grey";
            document.getElementById('profQuizPopUpEneSD').style.display = 'none';
            document.getElementById('profQuizPopUpEneST').style.display = 'none';
            document.getElementById('profQuizPopUpBtn_2').style.display = 'none';
            if (qResultFlag === true) {
                handleRadioBtns('stud_sub');
            } else {
                handleRadioBtns(selResOpt);
            }
            setProfQuizPopUpTitle(`${qName} for ${qClass} Quiz Assignment Information`);
        }
    }
    useEffect(() => {
        showRequiredModalDivs();
    }, []);
    useEffect(() => {
        showRequiredModalDivs();
        setFAssignQPP(false);
    }, [fAssignQPP === true]);
    function dateConversion(beforeFormatDate) {
        return (new Intl.DateTimeFormat('en-US',
            {
                year: 'numeric',
                month: 'long',
                day: '2-digit',
            }).format(beforeFormatDate)
        );
    }
    function timeConversion() {
        return (new Date().toLocaleTimeString('en-US',
            {
                timeZone: qTimeZone,
                hour12: true,
                hour: '2-digit',
                minute: '2-digit'
            })
        )
    }
    function timeRange(setRangeVal, setRangeType) {
        if (setRangeType === 'hrs') {
            var val = Array.from({ length: setRangeVal }, (_, i) => i + 1);
            return val;
        } else {
            var val = Array.from(Array(setRangeVal).keys());
            return val;
        }
    }
    function handleCheckBox() {
        var localCurrDT = moment(new Date()).format("YYYY-MM-DD hh:mm A"),
            selectedDT = format(startDate, 'yyyy-MM-dd') + " " + startHrs + ":" + startMins + " " + startType;
        if (checkBox === false) {
            setCheckBox(true);
            if (localCurrDT !== selectedDT) {
                setStartDate(new Date());
                setSelStartHrs(localCurrTS_1[0]);
                setSelStartMins(localCurrTS_2[0]);
                setSelStartType(localCurrTS_2[1]);
            }
        } else {
            setCheckBox(false);
        }
    }
    function handleStartDate(selectedDate) {
        setStartDate(selectedDate);
        var localCurrDT = moment(new Date()).format("YYYY-MM-DD hh:mm A"),
            selectedDT = format(selectedDate, 'yyyy-MM-dd') + " " + startHrs + ":" + startMins + " " + startType;
        if (localCurrDT === selectedDT) {
            setCheckBox(true);
        } else {
            setCheckBox(false);
        }
    }
    function handleStartTime(targetValue, targetTime) {
        var localCurrDT = moment(new Date()).format("YYYY-MM-DD hh:mm A"),
            selectedD = format(startDate, 'yyyy-MM-dd') + " ", selectedST;
        if (targetTime === 'hrs') {
            setSelStartHrs(targetValue);
            selectedST = targetValue + ":" + selStartMins + " " + selStartType;
        } else if (targetTime === 'mins') {
            setSelStartMins(targetValue);
            selectedST = selStartHrs + ":" + targetValue + " " + selStartType;
        } else if (targetTime === 'type') {
            setSelStartType(targetValue);
            selectedST = selStartHrs + ":" + selStartMins + " " + targetValue;
        }
        var selectedDT = selectedD + selectedST;
        if (localCurrDT === selectedDT) {
            setCheckBox(true);
        } else {
            setCheckBox(false);
        }
    }
    function handleRadioBtns(btnId) {
        setSelResOpt(btnId);
        if (btnId === 'quiz_end') {
            setQeResOpt(true);
            setStudSubResOpt(false);
            setDrResOpt(false);
        } else if (btnId === 'stud_sub') {
            setQeResOpt(false);
            setStudSubResOpt(true);
            setDrResOpt(false);
        } else if (btnId === 'date_range') {
            setQeResOpt(false);
            setStudSubResOpt(false);
            setDrResOpt(true);
        }
    }
    function handleAssignNextBtn() {
        var selectedST = selStartHrs + ':' + selStartMins + selStartType;
        var selectedET = selEndHrs + ':' + selEndMins + selEndType;
        var endDT = selEndHrs + ':' + selEndMins + " " + selEndType;
        var qSemEDConv = qSemED.split('at');
        var qSemET = qSemEDConv[1].split(' ');
        var semStartTime = qSemSDSplitTime[0] + qSemSDSplitTime[1];
        if (endDate === ' ' || (selectedET.indexOf(' ') >= 0)) {
            setLaterSemSelErr(false);
            setNoEDTSelErr(true);
        } else if ((endDate <= startDate && moment(selectedST, 'h:mma').isSameOrAfter(moment(selectedET, 'h:mma'))) ||
            new Date(localCurrDate) >= endDate && moment(localCurrTime, 'h:mm a').isSameOrAfter(moment(endDT, 'h:mm a'))) {
            setLaterSemSelErr(false);
            setNoEDTSelErr(false);
            setLaterEDTSelErr(true);
        } else if (new Date(qSemEDConv[0]) <= endDate && moment(selectedET, 'h:mma').isSameOrAfter(moment((qSemET[1] + qSemET[2]), 'h:mma'))) {
            setLaterSemSelErr(false);
            setNoEDTSelErr(false);
            setLaterEDTSelErr(false);
            setSemExpiredErr(true);
        } else if (selResOpt === ' ') {
            setLaterSemSelErr(false);
            setNoEDTSelErr(false);
            setLaterEDTSelErr(false);
            setNoResOptSelErr(true);
            setSemExpiredErr(false);
        } else {
            setLaterSemSelErr(false);
            setShowAssignQuizPopUp(false);
            setNoEDTSelErr(false);
            setLaterEDTSelErr(false);
            setNoResOptSelErr(false);
            setSemExpiredErr(false);
            if (selResOpt === 'quiz_end' || selResOpt === 'stud_sub') {
                setTimeout(() => { setShowResOptNxtPopup(true); }, 200);
            } else {
                setShowResOptPopUp(true);
            }
        }
    }
    function handleAssignOptBackBtn() {
        setNoClDTSelErr(false);
        setLaterRDTSelErr(false);
        setLaterClDTSelErr(false);
        setShowAssignQuizPopUp(true);
        setShowResOptPopUp(false);
        setFAssignQPP(true);
    }
    function handleAssignOptNextBtn() {
        var selectedST = selStartHrs + ':' + selStartMins + selStartType;
        var selectedRT =
            (selRelHrs === " " ? selEndHrs : selRelHrs) + ':' +
            (selRelMins === " " ? selEndMins : selRelMins) +
            (selRelType === " " ? selEndType : selRelType);
        var selectedCT = selCloHrs + ':' + selCloMins + selCloType;
        var selectedCTLen = selectedCT.split(' ').length;
        var selCT = selCloHrs + ':' + selCloMins + " " + selCloType;
        if ((releaseDate === " " ? endDate : releaseDate) <= startDate &&
            moment(selectedST, 'h:mma').isSameOrAfter(moment(selectedRT, 'h:mma'))) {
            setLaterRDTSelErr(true);
        } else if ((closeDate !== ' ' && (selectedCT.indexOf(' ') >= 0)) ||
            (closeDate === ' ' && (selectedCTLen - 1 !== 3))) {
            setLaterRDTSelErr(false);
            setNoClDTSelErr(true);
        } else if (closeDate < (releaseDate === " " ? endDate : releaseDate) && closeDate !== " " ||
            (closeDate <= (releaseDate === " " ? endDate : releaseDate) &&
                moment(selectedRT, 'h:mma').isSameOrAfter(moment(selectedCT, 'h:mma'))) ||
            (new Date(localCurrDate) >= closeDate && moment(localCurrTime, 'h:mm a').isSameOrAfter(moment(selCT, 'h:mm a')))) {
            setLaterRDTSelErr(false);
            setNoClDTSelErr(false);
            setLaterClDTSelErr(true);
        } else {
            setShowResOptPopUp(false);
            setLaterRDTSelErr(false);
            setNoClDTSelErr(false);
            setLaterClDTSelErr(false);
            setShowResOptNxtPopup(true);
        }
    }
    function endQuiz() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": '',
                    "cqClassId": qClassId,
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "qpProductId": qProductId,
                    "lastReadSubSectionId": "",
                    "qpQuizIdentifier": qIdentifier,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "lastViewedCQSemesterId": qSemId,
                },
                "sessionVO": getSessionVO()
            },
            "qpQuizVO": { "id": qId }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageCQ/endQuiz`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    props.onHide();
                    var estTime = moment.tz(new Date(), "America/New_York")
                    var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
                    var UpED = dateConversion(new Date()) + " at " + timeConversion() + " " + locTimeZon;
                    var AQStartT = selStartHrs + ':' + selStartMins + ' ' + selStartType;
                    var UpSD = dateConversion(startDate) + " at " + AQStartT + " " + locTimeZon;
                    var dqRelOption;
                    if (drResopt === true) {
                        dqRelOption = 'date_range';
                    } else if (studSubResOpt === true) {
                        dqRelOption = 'stud_sub';
                    } else if (qeResOpt === true) {
                        dqRelOption = 'quiz_end';
                    }
                    props.handleQuizStatus('completed', UpED, UpSD, dqRelOption);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function cancelQuiz() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classVO": { "cqClassId": qClassId },
            "quizVO": { "id": qId, "qpQuizIdentifier": qIdentifier }
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/manageProfessor/Cancel-Quiz`, requestOptions)
            .then(handleResponse)
            .then(response => response.text())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data === 'Success') {
                    props.onHide();
                    var estTime = moment.tz(new Date(), "America/New_York")
                    var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
                    var AQStartT = selStartHrs + ':' + selStartMins + ' ' + selStartType;
                    let AQEndT = selEndHrs + ':' + selEndMins + ' ' + selEndType;
                    var UpSD = dateConversion(startDate) + " at " + AQStartT + " " + locTimeZon;
                    var UpED = dateConversion(endDate) + " at " + AQEndT + " " + locTimeZon;
                    props.handleQuizStatus('yet to schedule', UpED, UpSD);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function assignQuiz() {
        var timezone = moment.tz.guess();
        var AQStartDate = moment.tz((moment(startDate).format("YYYY-MM-DD") + ' ' +
            (selStartType === "PM" ? (selStartHrs === "12" ? (selStartHrs) : (12 + Number(selStartHrs))) : (selStartHrs === "12" ? "00" : (selStartHrs))) + ':' + selStartMins), timezone);
        var AQEndDate = moment.tz((moment(endDate).format("YYYY-MM-DD") + ' ' +
            (selEndType === "PM" ? (selEndHrs === "12" ? (selEndHrs) : (12 + Number(selEndHrs))) : (selEndHrs === "12" ? "00" : (selEndHrs))) + ':' + selEndMins), timezone);
        var AQStartT = selStartHrs + ':' + selStartMins + ' ' + selStartType;
        let AQEndT = selEndHrs + ':' + selEndMins + ' ' + selEndType;
        let AQReleT = (selRelHrs === ' ' ? selEndHrs : selRelHrs) + ':' + (selRelMins === ' ' ? selEndMins : selRelMins) + ' ' + (selRelType === ' ' ? selEndType : selRelType);
        let AQClsT = selCloHrs + ':' + selCloMins + ' ' + selCloType;
        var AQscheduleStatus;
        if (format(new Date(localCurrDate), 'MM-dd-yyyy') === format(startDate, 'MM-dd-yyyy')) {
            if (moment(AQStartT, 'h:mm a').isAfter(moment(localCurrTime, 'h:mm a'))) {
                AQscheduleStatus = true;
            } else {
                AQscheduleStatus = false;
            }
        }
        else if (new Date(localCurrDate) < new Date(format(startDate, 'MM-dd-yyyy'))) {
            AQscheduleStatus = true;
        } else {
            AQscheduleStatus = false;
        }
        if (closeDate !== ' ') {
            var AQCloseDate = moment.tz((moment(closeDate).format("YYYY-MM-DD") + ' ' +
                (selCloType === "PM" ? (selCloHrs === "12" ? (selCloHrs) : (12 + Number(selCloHrs))) : (selCloHrs === "12" ? "00" : (selCloHrs))) + ':' + selCloMins), timezone);
        } else {
            var AQCloseDate = moment.tz(('3000-01-01 00:00'), timezone);
        }
        if (drResopt === true) {
            var relDate = releaseDate !== ' ' ? releaseDate : endDate,
                relHrs = selRelHrs !== ' ' ? selRelHrs : selEndHrs,
                relMins = selRelMins !== ' ' ? selRelMins : selEndMins,
                relType = selRelType !== ' ' ? selRelType : selEndType;
            var AQReleaseDate = moment.tz((moment(relDate).format("YYYY-MM-DD") + ' ' +
                (relType === "PM" ? (relHrs === "12" ? (relHrs) : (12 + Number(relHrs))) : (relHrs === "12" ? "00" : (relHrs))) + ':' + relMins), timezone);
        } else {
            var AQReleaseDate = '';
        }
        var estTime = moment.tz(new Date(), "America/New_York")
        var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
        var UpSD = dateConversion(startDate) + " at " + AQStartT + " " + locTimeZon;
        var UpED = dateConversion(endDate) + " at " + AQEndT + " " + locTimeZon;
        var upRD = dateConversion(releaseDate === ' ' ? endDate : releaseDate) + " at " + AQReleT + " " + locTimeZon;
        if (closeDate !== ' ') {
            var upCD = dateConversion(closeDate) + " at " + AQClsT + " " + locTimeZon;
        } else {
            var upCD = ''
        }
        let dqRelOption;
        if (drResopt === true) {
            dqRelOption = 'date_range';
        } else if (studSubResOpt === true) {
            dqRelOption = 'stud_sub';
        } else if (qeResOpt === true) {
            dqRelOption = 'quiz_end';
        }
        var quizAssigned = AQscheduleStatus === true ? false : true;
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classVO": { "cqClassId": qClassId },
            "quizVO": {
                "id": qId,
                "quizId": "",
                "qpQuizId": 0,
                "createdBy": 0,
                "modifiedBy": 0,
                "assigned": true,
                "cqClassName": "",
                "closeOption": "",
                "completedCount": 0,
                "notifyEmail": true,
                "quizIdentifier": "",
                "completedFlag": true,
                "qpQuizDescription": "",
                "notificationOption": "",
                "scheduled": AQscheduleStatus,
                "qpQuizIdentifier": qIdentifier,
                "quizEndDate": estTimeConv(AQEndDate),
                "closeDate": estTimeConv(AQCloseDate),
                "quizStartDate": estTimeConv(AQStartDate),
                "publishResultInstantlyFlag": studSubResOpt,
                "releaseOption": drResopt === true ? 'date_range' : '',
                "releaseDate": drResopt === true ? estTimeConv(AQReleaseDate) : '',
            }
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/manageProfessor/assignQuiz`, requestOptions)
            .then(handleResponse)
            .then(response => response.text())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data === "Success") {
                    props.onHide();
                    props.handleQuizStatus(AQscheduleStatus === true ? 'scheduled' : 'active', UpED, UpSD, dqRelOption, upRD, upCD, quizAssigned);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function updateAssingedQuiz() {
        var timezone = moment.tz.guess();
        var AQStartDate = moment.tz((moment(startDate).format("YYYY-MM-DD") + ' ' +
            (selStartType === "PM" ? (selStartHrs === "12" ? (selStartHrs) : (12 + Number(selStartHrs))) : (selStartHrs === "12" ? "00" : (selStartHrs))) + ':' + selStartMins), timezone);
        var AQEndDate = moment.tz((moment(endDate).format("YYYY-MM-DD") + ' ' +
            (selEndType === "PM" ? (selEndHrs === "12" ? (selEndHrs) : (12 + Number(selEndHrs))) : (selEndHrs === "12" ? "00" : (selEndHrs))) + ':' + selEndMins), timezone);
        var AQStartT = selStartHrs + ':' + selStartMins + ' ' + selStartType;
        let AQEndT = selEndHrs + ':' + selEndMins + ' ' + selEndType;
        let AQReleT = (selRelHrs === ' ' ? selEndHrs : selRelHrs) + ':' + (selRelMins === ' ' ? selEndMins : selRelMins) + ' ' + (selRelType === ' ' ? selEndType : selRelType);
        let AQClsT = selCloHrs + ':' + selCloMins + ' ' + selCloType;
        if (closeDate !== ' ') {
            var AQCloseDate = moment.tz((moment(closeDate).format("YYYY-MM-DD") + ' ' +
                (selCloType === "PM" ? (selCloHrs === "12" ? (selCloHrs) : (12 + Number(selCloHrs))) : (selCloHrs === "12" ? "00" : (selCloHrs))) + ':' + selCloMins), timezone);
        } else {
            var AQCloseDate = moment.tz(('3000-01-01 00:00'), timezone);
        }
        if (drResopt === true) {
            if (releaseDate !== " ") {
                var AQReleaseDate = moment.tz((moment(releaseDate).format("YYYY-MM-DD") + ' ' +
                    (selRelType === "PM" ? (selRelHrs === "12" ? (selRelHrs) : (12 + Number(selRelHrs))) : (selRelHrs === "12" ? "00" : (selRelHrs))) + ':' + selRelMins), timezone);
            } else {
                var AQReleaseDate = AQEndDate;
            }
        } else {
            var AQReleaseDate = '';
        }
        var estTime = moment.tz(new Date(), "America/New_York")
        var locTimeZon = estTime.clone().tz(moment.tz.guess()).format('z');
        var UpSD = dateConversion(startDate) + " at " + AQStartT + " " + locTimeZon;
        var UpED = dateConversion(endDate) + " at " + AQEndT + " " + locTimeZon;
        var upRD = dateConversion(releaseDate === ' ' ? endDate : releaseDate) + " at " + AQReleT + " " + locTimeZon;
        if (closeDate !== ' ') {
            var upCD = dateConversion(closeDate) + " at " + AQClsT + " " + locTimeZon;
        } else {
            var upCD = ''
        }
        let dqRelOption;
        if (drResopt === true) {
            dqRelOption = 'date_range';
        } else if (studSubResOpt === true) {
            dqRelOption = 'stud_sub';
        } else if (qeResOpt === true) {
            dqRelOption = 'quiz_end';
        }
        if (qBtn === 'Edit scheduled assignment') {
            var shStatus = 'scheduled'
        } else if (qBtn === 'Edit active assignment') {
            var shStatus = 'active'
        } else if (qBtn === 'Reopen Quiz') {
            var shStatus = 'active'
        }
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "classVO": {
                "className": qClass,
                "professorEmail": "",
                "cqClassId": qClassId,
                "professorQuizSetName": "",
                "professorUserId": qpUserId,
                "qpQuizIdentifier": qIdentifier,
                "endDate": estTimeConv(AQEndDate),
                "startDate": estTimeConv(AQStartDate),
            },
            "quizVO": {
                "id": qId,
                "cqClassId": qClassId,
                "qpQuizIdentifier": qIdentifier,
                "mailOverride": mailCheckboxActive,
                "notificationOption": "unsubmitted",
                "closeDate": estTimeConv(AQCloseDate),
                "quizEndDate": estTimeConv(AQEndDate),
                "quizStartDate": estTimeConv(AQStartDate),
                "publishResultInstantlyFlag": studSubResOpt,
                "releaseOption": drResopt === true ? 'date_range' : 'quiz_end',
                "releaseDate": drResopt === true ? estTimeConv(AQReleaseDate) : '',
            }
        }
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/manageProfessor/updateAssingedQuizDate`, requestOptions)
            .then(handleResponse)
            .then(response => response.text())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                if (data === "Updated Successfully") {
                    props.onHide();
                    props.handleQuizStatus(shStatus, UpED, UpSD, dqRelOption, upRD, upCD);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    function estTimeConv(convDT) {
        var estTime = convDT.clone().tz("America/New_York");
        var manipulateEstTime = estTime;
        estTime = separateDateTimeZon(estTime.format());
        var exactHr = manipulateEstTime.hours();
        var exactMins = manipulateEstTime.minutes(), meridian = "";
        if (exactHr > 12) {
            exactHr = exactHr - 12;
            meridian = "PM"
        } else if (exactHr == 12) {
            meridian = "PM";
        } else {
            meridian = "AM"
        }
        if (exactHr < 10) {
            exactHr = "0" + exactHr;
        }
        if (exactMins < 10) {
            exactMins = "0" + exactMins;
        }
        return estTime + " " + exactHr + ":" + exactMins + ":00 " + meridian
    }
    function separateDateTimeZon(sDate) {
        var splitSDate = sDate.split("T");
        var jointSDate = splitSDate[0].split("-");
        return jointSDate[1] + "-" + jointSDate[2] + "-" + jointSDate[0];
    }
    function setDatePickerLableAndRole(docId, ariaLabel) {
        if ((docId && ariaLabel) != null) {
            let getParentClass = document.querySelector(docId);
            let getSubClass = getParentClass.querySelector(".react-datepicker");
            getSubClass.setAttribute("role", "dialog");
            getSubClass.setAttribute("aria-label", ariaLabel);
            let getMonthClass = getParentClass.querySelector(".react-datepicker__month");
            getMonthClass.removeAttribute("aria-label");
            getMonthClass.removeAttribute("role");
            let getWeekClass = getParentClass.querySelector(".react-datepicker__week");
            getWeekClass.removeAttribute("aria-label");
            getWeekClass.removeAttribute("role");
            let getDayClass = getParentClass.querySelectorAll(".react-datepicker .react-datepicker__day");
            for (var i = 0; i < getDayClass.length; i++) {
                getDayClass[i].setAttribute("role", "button");
            }
            let getCurrentMonth = getParentClass.querySelector(".react-datepicker__current-month");
            getCurrentMonth.setAttribute("role", "heading");
            getCurrentMonth.setAttribute("aria-level", "2");

        }
    }

    const onEnteredShowAssignQuizPopUp = ()=>{
        let popupTitle = document.getElementsByClassName("cqProfQuizPopUpModalMinWidth");
        popupTitle[0].parentElement.setAttribute("aria-label",profQuizPopUpTitle);
    }
    
    return (
        <div>
            <Modal
                show={showAssignQuizPopUp}
                onHide={props.onHide}
                backdrop="static" size="sm"
                role="dialog"
                centered dialogClassName="cqProfQuizPopUpModalMinWidth m-auto"
                onEntered={onEnteredShowAssignQuizPopUp}
            >
                <button ref={cqProfQuizPopUpCloseRef} type="button" className="close text-right cqProfQuizPopUpClose"
                    onClick={props.onHide} data-dismiss="modal" aria-label="Close Dialog">&times;</button>
                <div className="cqProfQuizPopUpHeader">
                    <div id="profQuizPopUpTitle_1" className="cqProfQuizPopUpTitle px-2" role="heading" aria-level="2"
                        style={{ maxWidth: '320px' }}>This quiz will no longer be assigned</div>
                    <div id="profQuizPopUpTitle_2" className="cqProfQuizPopUpTitle px-2" role="heading" aria-level="2"
                        style={{ maxWidth: '320px' }}>No new submissions will be permitted</div>
                    <div id="profQuizPopUpTitle_3" className="cqProfQuizPopUpTitle px-2" role="heading" aria-level="2">{qName} for {qClass}</div>
                </div>
                <div className="cqProfQuizPopUpBodyContainer">
                    <div id="profQuizPopUpBodyTxt_1" className="cqProfQuizPopUpBody mx-4">
                        Do you want to cancel this quiz?
                    </div>
                    <div id="profQuizPopUpBodyTxt_2" className="cqProfQuizPopUpBody mx-4">
                        Do you want to end this quiz?
                    </div>
                    <div id="profQuizPopUpBodyTxt_3">
                        <div className="form-check text-center mb-2">
                            <input data-testid="checkbox_start_immediately" type="checkbox" id="profQuizPopUpCheckBox" name="start quiz" value="quiz"
                                className="cqProfQuizPopUpCheck form-check-input" onChange={handleCheckBox} checked={checkBox}></input>
                            <label htmlFor="profQuizPopUpCheckBox" id="profQuizPopUpCheckBoxTxt" className="cqProfQuizPopUpStartTxt">Start Quiz Immediately</label>
                        </div>
                        <form className="col-12">
                            {laterSemSelErr && (
                                <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpErrorMsg ml-2"> Error:Please Select after Semester active date and time.</div>
                            )
                            }
                            <div className="form-row mb-1">
                                <label htmlFor="cqProfQuizPopUpSelectIcon" className="cqProfQuizPopUpDateTimeLabel col-xl-4 col-lg-4 col-md-4 col-4 col-form-label">Start Date</label>
                                <div data-testid="start_date_calendar" id="profQuizPopUpEneSD" className="col-xl-8 col-lg-8 col-md-8 col-8 p-0" onClick={() => setDatePickerLableAndRole('#profQuizPopUpEneSD', 'Quiz Start Date Picker')}>
                                    <DatePicker ariaLabelledBy="cqProfQuizPopUpSelectIcon" id="cqProfQuizPopUpSelectIcon" className="cqProfQuizPopUpDateTimeInput w-100 cqProfQuizPopUpSelectIcon" dateFormat="MMMM dd, yyyy"
                                        minDate={new Date(qSemSDSplit[0]) <= new Date() ? new Date() : new Date(qSemSDSplit[0])} selected={startDate}
                                        maxDate={qSemMaxDate} onChange={(date) => handleStartDate(date)}
                                        onCalendarOpen={() => setIsStartDateCalendarOpen(true)}
                                        onCalendarClose={() => setIsStartDateCalendarOpen(false)}
                                        customInput={<DateInput testid="input_calendar_start_date" isOpen={isStartDateCalendarOpen} />}
                                    />
                                </div>
                                <div className="col-xl-8 col-lg-8 col-md-8 col-8 p-0">
                                    <input aria-label="Start Date" id="profQuizPopUpDisSD" className="cqProfQuizPopUpDateTimeInput w-100"
                                        value={dateConversion(startDate)} disabled />
                                </div>
                            </div>
                            <fieldset className="p-0 m-0 border-0">
                                <div className="form-row mb-1">
                                    
                                    <label htmlFor="profStartHrsDtTime" className="cqProfQuizPopUpDateTimeLabel col-form-label col-xl-4 col-lg-4 col-md-4 col-4">
                                        <legend style={{fontSize:"15px"}}>
                                            Hours
                                        </legend>
                                    </label>
                                        <div id="profQuizPopUpEneST" className='col-xl-8 col-lg-8 col-md-8 col-8'>
                                            <div className="form-row">
                                                <div className="col-4 pl-0">
                                                    <select data-testid="startHrs" aria-label="Hours" id="profStartHrsDtTime" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                        value={selStartHrs} onChange={(e) => handleStartTime(e.target.value, 'hrs')}>
                                                        {
                                                            startHrs.map((hour, index) => {
                                                                return (
                                                                    <option key={'profStartHrs' + index} id={'profStartHrs' + (hour < 10 ? `0${hour}` : `${hour}`)} value={(hour < 10 ? `0${hour}` : `${hour}`)}>
                                                                        {hour < 10 ? `0${hour}` : `${hour}`}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-4">
                                                    <select data-testid="startMins" aria-label="Minutes" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                        value={selStartMins} onChange={(e) => handleStartTime(e.target.value, 'mins')}>
                                                        {
                                                            startMins.map((mins, index) => {
                                                                return (
                                                                    <option key={'profStartMins' + index} id={'profStartMins' + (mins < 10 ? `0${mins}` : `${mins}`)} value={(mins < 10 ? `0${mins}` : `${mins}`)}>
                                                                        {mins < 10 ? `0${mins}` : `${mins}`}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-4 pr-0">
                                                    <select data-testid="startTimeType" aria-label="Time Period" className="form-control cqProfQuizPopUpDateTimeInput px-1 py-1"
                                                        value={selStartType} onChange={(e) => handleStartTime(e.target.value, 'type')}>
                                                        {
                                                            startType.map((typ, index) => {
                                                                return (
                                                                    <option key={'profStart' + index} id={'profStart' + (typ)} value={typ}>
                                                                        {typ}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    <input aria-label="Hours" id="profQuizPopUpDisST" className="col-xl-8 col-lg-8 col-md-8 col-8 cqProfQuizPopUpDateTimeInput form-control"
                                        value={qSDSplitTime[0] + ' ' + qSDSplitTime[1]} disabled />
                                </div>
                            </fieldset>
                            {
                                laterEDTSelErr && (
                                    <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpErrorMsg pr-0">
                                        Error: Select a later End Date and Time.
                                    </div>
                                )
                            }
                            {
                                noEDTSelErr && (
                                    <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpErrorMsg pr-0">
                                        Error: Select an End Date and Time.
                                    </div>
                                )
                            }
                            {
                                semExpiredErr && (
                                    <div style={{ marginLeft: '3%', textAlign: 'center' }} className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpErrorMsg pr-0">
                                        Error: Please select a date and time before the semester ends.
                                    </div>
                                )
                            }
                            <div className="form-row mb-1">
                                <label htmlFor="cqProfQuizPopUpDateTimeEd" className="cqProfQuizPopUpDateTimeLabel col-xl-4 col-lg-4 col-md-4 col-4 col-form-label">End Date</label>
                                <div data-testid="end_date_calendar" id="profQuizPopUpDPED" className="col-xl-8 col-lg-8 col-md-8 col-8 p-0" onClick={(e) => setDatePickerLableAndRole("#profQuizPopUpDPED", 'Quiz End Date Picker')}>
                                    <DatePicker id="cqProfQuizPopUpDateTimeEd" className="cqProfQuizPopUpDateTimeInput w-100 cqProfQuizPopUpSelectIcon" dateFormat="MMMM dd, yyyy"
                                        minDate={qBtn === 'Edit active assignment' || qBtn === 'Reopen Quiz' ? new Date() : startDate} selected={endDate !== ' ' && endDate}
                                        maxDate={qSemMaxDate} onChange={(date) => setEndDate(date)}
                                        onCalendarOpen={() => setIsEndDateCalendarOpen(true)}
                                        onCalendarClose={() => setIsEndDateCalendarOpen(false)}
                                        customInput={<DateInput testid="input_calendar_end_date" isOpen={isEndDateCalendarOpen} />}
                                    />
                                </div>
                            </div>
                            <fieldset className="p-0 m-0 border-0">
                                <div className="form-row mb-1">
                                    <label htmlFor="endHrs" className="cqProfQuizPopUpDateTimeLabel col-form-label col-xl-4 col-lg-4 col-md-4 col-4">
                                        <legend style={{fontSize:"15px"}}>
                                            Hours
                                        </legend>
                                    </label>
                                    <div className='col-xl-8 col-lg-8 col-md-8 col-8'>
                                        <div className="form-row">
                                            <div className="col-4 pl-0 ">
                                                <select data-testid="endHrs" id="endHrs" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                    value={selEndHrs} onChange={(e) => setSelEndHrs(e.target.value)}>
                                                    <option style={{ display: "none" }}></option>
                                                    {
                                                        endHrs.map((hour, index) => {
                                                            return (
                                                                <option key={'profEndHrs' + index} id={'profEndHrs' + (hour < 10 ? `0${hour}` : `${hour}`)} value={(hour < 10 ? `0${hour}` : `${hour}`)}>
                                                                    {(hour < 10 ? `0${hour}` : `${hour}`)}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-4">
                                                <select data-testid="endMins" aria-label="Minutes" id="endMins" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                    value={selEndMins} onChange={(e) => setSelEndMins(e.target.value)}>
                                                    <option style={{ display: "none" }}></option>
                                                    {
                                                        endMins.map((mins, index) => {
                                                            return (
                                                                <option key={'profEndMin' + index} id={'profEndMin' + (mins < 10 ? `0${mins}` : `${mins}`)} value={(mins < 10 ? `0${mins}` : `${mins}`)}>
                                                                    {(mins < 10 ? `0${mins}` : `${mins}`)}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-4 pr-0">
                                                <select data-testid="endTimeType" aria-label="Time Period" id="endTimeType" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                    value={selEndType} onChange={(e) => setSelEndType(e.target.value, 'type')}>
                                                    <option style={{ display: "none" }}></option>
                                                    {
                                                        endType.map((typ, index) => {
                                                            return (
                                                                <option key={'profEnd' + index} id={'profEnd' + (typ)} value={typ}>
                                                                    {typ}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            {
                                noResOptSelErr && (
                                    <div style={{ marginLeft: '6%' }} className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpErrorMsg pr-0">
                                        Error: Select a student result release option.
                                    </div>
                                )
                            }
                            <fieldset className="p-0 m-0 border-0">
                                <legend className="p-0 m-0">
                                <p className='cqProfQuizPopUpDateTimeLabel mt-2 ml-2' style={{ textAlign: "left", margin: "0px" }}>
                                    Release Detailed Results for Students
                                </p>
                                </legend>
                                <div className='ml-5'>
                                    
                                        <div className="form-check">
                                            <label htmlFor="quiz_end" className="form-check-label cqProfQuizPopUpResultBtns mb-2">
                                                <input data-testid="radio_after_quiz_end_date" type="radio" id="quiz_end" className="after-quiz-end-date form-check-input"
                                                    name="quizRelOpts" onChange={() => handleRadioBtns("quiz_end")} checked={qeResOpt} />After quiz end date
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <label htmlFor="stud_sub" className="form-check-label cqProfQuizPopUpResultBtns mb-2">
                                                <input data-testid="radio_upon_quiz_student_submission" type="radio" id="stud_sub" className="upon-student-submission form-check-input"
                                                    name="quizRelOpts" onChange={() => handleRadioBtns("stud_sub")} checked={studSubResOpt} />Upon student submission
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <label htmlFor="date_range" className="date-range form-check-label cqProfQuizPopUpResultBtns">
                                                <input data-testid="radio_date_range" type="radio" id="date_range" className="form-check-input"
                                                    name="quizRelOpts" onChange={() => handleRadioBtns("date_range")} checked={drResopt} />Date Range
                                            </label>
                                        </div>
                                    
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
                <div className="cqProfQuizPopUpFooter">
                    <button id="profQuizPopUpBtn_1" className="cqProfQuizPopUpNxtBtn" onClick={handleAssignNextBtn}>Next</button>
                    <div id="profQuizPopUpBtn_2">
                        <button className="cqProfQuizPopUpNoBtn mr-2" onClick={props.onHide}>No</button>
                        <button className="cqProfQuizPopUpYesBtn" onClick={qBtn === 'Cancel Quiz' ? () => cancelQuiz() : () => endQuiz()}>Yes</button>
                    </div>
                </div>
            </Modal>
            <Modal
                show={showResOptNxtPopup}
                onHide={props.onHide}
                backdrop="static" size="sm"
                aria-label="Quiz Assignment Confirmation"
                role="dialog"
                centered
            >
                <button ref={cqProfQuizPopUpCloseConfirmRef} type="button" className="close text-right cqProfQuizPopUpClose"
                    onClick={props.onHide} data-dismiss="modal" aria-label="Close Dialog">&times;</button>
                <div className="cqProfQuizPopUpHeader">
                    <div className="cqProfQuizPopUpTitle px-2" role="heading" aria-level="2" style={{ width: '360px' }}>
                        You are about to assign {qName} to {qClass}
                    </div>
                </div>
                <div className="cqProfQuizPopUpBody">
                    <div className="cqProfQuizPopUpBody mx-4">
                        Do you want to assign this quiz?
                    </div>
                </div>
                <div className="cqProfQuizPopUpFooter">
                    <button className="cqProfQuizPopUpNoBtn mr-2"
                        onClick={() => [setShowAssignQuizPopUp(true), setShowResOptNxtPopup(false), setFAssignQPP(true)]}>No</button>
                    <button className="cqProfQuizPopUpYesBtn" onClick={qBtn === 'Assign to class' ? () => assignQuiz() : () => updateAssingedQuiz()}>Yes</button>
                </div>
            </Modal>
            <Modal
                show={showResOptPopUp}
                onHide={props.onHide}
                backdrop="static" size="sm"
                aria-label={`${qName} for ${qClass} Quiz Time Frame Information`}
                role="dialog"
                centered dialogClassName="cqProfQuizPopUpModalMinWidth m-auto"
            >
                <button type="button" className="close text-right cqProfQuizPopUpClose"
                    onClick={props.onHide} data-dismiss="modal">&times;</button>
                <div className="cqProfQuizPopUpHeader">
                    <div className="cqProfQuizPopUpTitle px-2" role="heading" aria-level="2">
                        {qName} for {qClass}
                    </div>
                </div>
                <div className="cqProfQuizPopUpBody">
                    <div className="cqProfQuizPopUpBody mx-2 mb-2" style={{ width: '316px' }}>
                        Your students will have access to their detailed results
                        for the timeframe you select. Close date and time are optional.
                    </div>
                    <div id="profQuizPopUpBodyTxt">
                        <form className="col-12">
                            <div className="form-row mb-1">
                                <label className="cqProfQuizPopUpDateTimeLabel col-xl-5 col-lg-5 col-md-5 col-5 col-form-label">Release Date</label>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-7 p-0">
                                    <DatePicker className="cqProfQuizPopUpDateTimeInput w-100 cqProfQuizPopUpSelectIcon" dateFormat="MMMM dd, yyyy"
                                        minDate={startDate} selected={releaseDate === ' ' ? endDate : releaseDate}
                                        maxDate={qSemMaxDate} onChange={(date) => setReleaseDate(date)}
                                        onCalendarOpen={() => setIsReleaseDateCalendarOpen(true)}
                                        onCalendarClose={() => setIsReleaseDateCalendarOpen(false)}
                                        customInput={<DateInput testid="input_calendar_release_date" isOpen={isReleaseDateCalendarOpen} />}
                                    />
                                </div>
                            </div>
                            <div className="form-row mb-1">
                                <label className="cqProfQuizPopUpDateTimeLabel col-form-label col-xl-5 col-lg-5 col-md-5 col-5">Release Time</label>
                                <div className='col-xl-7 col-lg-7 col-md-7 col-7'>
                                    <div className="form-row">
                                        <div className="col-4 pl-0">
                                            <select data-testid="relHrs" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                value={selRelHrs === ' ' ? selEndHrs : selRelHrs} onChange={(e) => setSelRelHrs(e.target.value)}>
                                                {
                                                    relHrs.map((hour, index) => {
                                                        return (
                                                            <option key={'profRelHrs' + index} id={'profRelHrs' + (hour < 10 ? `0${hour}` : `${hour}`)} value={(hour < 10 ? `0${hour}` : `${hour}`)}>
                                                                {hour < 10 ? `0${hour}` : `${hour}`}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-4">
                                            <select data-testid="relMins" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                value={selRelMins === ' ' ? selEndMins : selRelMins} onChange={(e) => setSelRelMins(e.target.value)}>
                                                {
                                                    relMins.map((mins, index) => {
                                                        return (
                                                            <option key={'profRelMins' + index} id={'profRelMins' + (mins < 10 ? `0${mins}` : `${mins}`)} value={(mins < 10 ? `0${mins}` : `${mins}`)}>
                                                                {mins < 10 ? `0${mins}` : `${mins}`}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-4 pr-0">
                                            <select data-testid="relType" className="form-control cqProfQuizPopUpDateTimeInput px-1 py-1"
                                                value={selRelType === ' ' ? selEndType : selRelType} onChange={(e) => setSelRelType(e.target.value)}>
                                                {
                                                    relType.map((typ, index) => {
                                                        return (
                                                            <option key={'profRel' + index} id={'profRel' + (typ)} value={typ}>
                                                                {typ}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                laterRDTSelErr && (
                                    <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpNxtErrorMsg pr-0 pl-4">
                                        Error: Please select a later Release Date and Time.
                                    </div>
                                )
                            }
                            {
                                laterClDTSelErr && (
                                    <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpNxtErrorMsg pr-0 pl-4">
                                        Error: Please select a later Close Date and Time or remove your selections.
                                    </div>
                                )
                            }
                            {
                                noClDTSelErr && (
                                    <div className="col-md-12 col-sm-12 col-xs-12 cqProfQuizPopUpNxtErrorMsg pr-0 ">
                                        Error: Please select a Close Date and Time or remove your selections.
                                    </div>
                                )
                            }
                            <div className="form-row mb-1">
                                <label className="cqProfQuizPopUpDateTimeLabel col-xl-5 col-lg-5 col-md-5 col-5 col-form-label">Close Date</label>
                                <div className="col-xl-7 col-lg-7 col-md-7 col-7 p-0 ">
                                    <DatePicker className="cqProfQuizPopUpDateTimeInput w-100 cqProfQuizPopUpSelectIcon" dateFormat="MMMM dd, yyyy"
                                        minDate={releaseDate === ' ' ? endDate : releaseDate} selected={closeDate !== ' ' && closeDate}
                                        maxDate={qSemMaxDate} onChange={(date) => setCloseDate(date)}
                                        onCalendarOpen={() => setIsCloseDateCalendarOpen(true)}
                                        onCalendarClose={() => setIsCloseDateCalendarOpen(false)}
                                        customInput={<DateInput testid="input_calendar_close_date" isOpen={isCloseDateCalendarOpen} />}
                                    />
                                </div>
                            </div>
                            <div className="form-row mb-1">
                                <label className="cqProfQuizPopUpDateTimeLabel col-form-label col-xl-5 col-lg-5 col-md-5 col-5">Close Time</label>
                                <div className='col-xl-7 col-lg-7 col-md-7 col-7'>
                                    <div className="form-row">
                                        <div className="col-4 pl-0 ">
                                            <select data-testid="cloHrs" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                value={selCloHrs} onChange={(e) => setSelCloHrs(e.target.value)}>
                                                <option style={{ display: "none" }}></option>
                                                {
                                                    cloHrs.map((hour, index) => {
                                                        return (
                                                            <option key={'profCloHrs' + index} id={'profCloHrs' + (hour < 10 ? `0${hour}` : `${hour}`)} value={(hour < 10 ? `0${hour}` : `${hour}`)}>
                                                                {(hour < 10 ? `0${hour}` : `${hour}`)}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-4">
                                            <select data-testid="cloMins" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                value={selCloMins} onChange={(e) => setSelCloMins(e.target.value)}>
                                                <option style={{ display: "none" }}></option>
                                                {
                                                    cloMins.map((mins, index) => {
                                                        return (
                                                            <option key={'profCloMin' + index} id={'profCloMin' + (mins < 10 ? `0${mins}` : `${mins}`)} value={(mins < 10 ? `0${mins}` : `${mins}`)}>
                                                                {(mins < 10 ? `0${mins}` : `${mins}`)}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-4 pr-0">
                                            <select data-testid="cloType" className="cqProfQuizPopUpDateTimeInput form-control px-1 py-1"
                                                value={selCloType} onChange={(e) => setSelCloType(e.target.value, 'type')}>
                                                <option style={{ display: "none" }}></option>
                                                {
                                                    cloType.map((typ, index) => {
                                                        return (
                                                            <option key={'profClo' + index} id={'profClo' + (typ)} value={typ}>
                                                                {typ}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="cqProfQuizPopUpFooter">
                    <button className="cqProfQuizPopUpNoBtn" onClick={handleAssignOptBackBtn}>Back</button>
                    <button className="cqProfQuizPopUpYesBtn" onClick={handleAssignOptNextBtn}>Next</button>
                </div>
            </Modal>
        </div>
    )
}
export default CQProfessorAssignmentPopUp;